// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610070635/js/" + chunkId + "." + {"44":"9bbd28a4","225":"144e5bf7","481":"900ed593","486":"258dc28a","770":"5578c4d6"}[chunkId] + ".0.4065448178307973.chunk.js";
};